/**
 * Výběr prvku v preview iframe → ui-context (chat ví, na co user ukázal).
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { setUiContext } from './ui-context';

export type InspectSelection = {
  selector: string;
  text?: string;
  tag?: string;
  id?: string | null;
  classes?: string | null;
};

export function useCodableInspect(iframeKey: number) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [inspect, setInspect] = useState(false);
  const [selection, setSelection] = useState<InspectSelection | null>(null);

  const sendInspect = useCallback((on: boolean) => {
    iframeRef.current?.contentWindow?.postMessage({ type: 'acm-inspect', on }, '*');
  }, []);

  const toggleInspect = useCallback(() => {
    setInspect((prev) => {
      const next = !prev;
      sendInspect(next);
      return next;
    });
  }, [sendInspect]);

  const clearSelection = useCallback(() => {
    setSelection(null);
    setUiContext({ selection: null });
  }, []);

  useEffect(() => {
    function onMsg(e: MessageEvent) {
      const d = e.data as InspectSelection & { type?: string };
      if (d?.type !== 'acm-selection' || !d.selector) return;
      const sel: InspectSelection = {
        selector: d.selector,
        text: d.text,
        tag: d.tag,
        id: d.id,
        classes: d.classes,
      };
      setSelection(sel);
      setUiContext({ selection: sel });
    }
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);

  useEffect(() => {
    if (!inspect) return;
    sendInspect(true);
    const t = window.setTimeout(() => sendInspect(true), 400);
    return () => clearTimeout(t);
  }, [inspect, iframeKey, sendInspect]);

  const onIframeLoad = useCallback(() => {
    if (inspect) sendInspect(true);
  }, [inspect, sendInspect]);

  return {
    iframeRef,
    inspect,
    selection,
    toggleInspect,
    clearSelection,
    onIframeLoad,
  };
}
